// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n/* 字体 */\n/* Colors\n-------------------------- */\n/* 尺寸\n-------------------------- */\n.addClass[data-v-30c2788e] {\n  padding-bottom: 78px;\n}\n.addClassHome[data-v-30c2788e] {\n  padding-bottom: 66px;\n}\n", ""]);
// Exports
module.exports = exports;
